import {getDataWithPromise, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const getClassForRegistration = (school_id, class_id, date, session, onCompleteFunc) =>
{
    const url =  Globals.APIFolder + '/school/' + school_id + '/registration/' + class_id ;

    const formData = {
        date: date,
        session: session
    }

    return getDataWithPromise(url, 'POST', {formData}).then(data =>
    {
        onCompleteFunc(data);
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const registerClass = (school_id, class_id, date, session, lunch, registrationData, pupils, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/school/' + school_id + '/registration/' + class_id + '/register';

    const formData = {
        date: date,
        session: session,
        lunch: lunch,
        pupils: pupils,
        registrationData: registrationData
    }

    return getDataWithPromise(url, 'POST', {formData})
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getPreviousLunchOption = (user_id, school_id, class_id, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/lunch/previous';

    const formData = {
        user_id: user_id
    }

    return getDataWithPromise(url, 'POST', {formData})
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getDatabaseAbsenceCodes = (onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/absenceCodes';

    return getDataWithPromise(url, 'GET')
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getMisWritebackEnabled = (school_id, onCompleteFunc) =>
{
    const url = Globals.APIFolder + '/wonde_school/' + school_id + '/enabled';

    return getDataWithPromise(url, 'GET')
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}